import { getBookingReportStyles } from './booking-report';
import { getShareOfVoiceStyles } from './share-of-voice';

export const getIntelligencePageStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  BookingReport: getBookingReportStyles(_, { palette, iconFontFamily }),
  ShareOfVoice: getShareOfVoiceStyles(_, { palette, iconFontFamily }),
});

export * from './feed-upload';
export * from './feed-status';
export * from './match-report';
export * from './callout-extension';
